import AgendaOnlineMeeting from "@/domain/entities/agenda/AgendaOnlineMeeting";
import { OnlineMeeting as OnlineMeetingSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const agendaOnlineMeetingToDomainMapper = (
    onlineMeeting: OnlineMeetingSDK,
): AgendaOnlineMeeting =>
    new AgendaOnlineMeeting({
        joinUrl: onlineMeeting.joinUrl,
        conferenceId: onlineMeeting.conferenceId,
        tollNumber: onlineMeeting.tollNumber,
    });

export default agendaOnlineMeetingToDomainMapper;
